/**
 * Подготовка данных для карточки «Состав и названия графиков» в настройках.
 *
 * Вынесено из компонента отдельным модулем сознательно: `@testing-library/react` в зависимостях
 * нет, компоненты тестами не покрываются, — а группировка и обещание «этот график появится на
 * такой-то вкладке» проверяться должны.
 */
import { CHART_TABS, groupAllChartsBySection } from '../nodes/nodeChartLayout';

/**
 * Карточки каталога, разложенные по вкладкам дашборда и секциям внутри них.
 * Пустые вкладки и секции отбрасываются, порядок пакета сохраняется.
 */
export const buildVisibilityGroups = (charts = []) => {
  const sections = groupAllChartsBySection(charts);

  return CHART_TABS
    .map((tab) => ({
      id: tab.id,
      title: tab.title,
      sections: sections
        .filter((section) => tab.sections.includes(section.id))
        .map((section) => ({
          id: section.id,
          title: section.title,
          charts: section.charts.map((entry) => entry.chart)
        }))
    }))
    .filter((tab) => tab.sections.length > 0);
};

/**
 * Состояние галок из каталога. `spec.hidden` уже эффективный — сервер применил настройку
 * тенанта поверх умолчания пакета, поэтому здесь достаточно инверсии.
 */
export const initialVisibility = (charts = []) =>
  Object.fromEntries(charts.map((chart) => [chart.id, chart.spec?.hidden !== true]));
